import authentication from '@feathersjs/authentication-client'

import { bugsnagClient } from '../../bugsnag'
import { castArray, empty, isArray, statusOptions } from '../../views/utils'
import client from '../client'

client.configure(authentication({
  idField: 'id',
  path: '/api/auth',
  storage: window.localStorage,
}))

const handlePayload = (payload, commit) => {
  commit('SET_PROFILE', payload)
  commit('SET_PERMISSIONS', payload.user.members[0].permissions)
  return Promise.resolve(payload)
}

const verifyJWT = ({ accessToken }) => {
  // save token
  if (accessToken) {
    window.localStorage['feathers-jwt'] = accessToken
    client.set('accessToken', accessToken)
  }

  return client.passport.verifyJWT(accessToken)
}

let whenAuth = Promise.resolve()

/* eslint-disable */
export default {
  store: {
    state: {
      doSkip: false,
      _user: {},
    },
    actions: {
      CHECK_LOGIN: ({ commit, state }) => {
        if (state.doSkip) return Promise.resolve()

        commit('SET_AUTH_SKIP', true)

        whenAuth = client
          .authenticate()
          .then(response => client.passport.verifyJWT(response.accessToken))
          .then(payload => handlePayload(payload, commit))
          .catch((err) => {
            if (err.name === 'NotAuthenticated') {
              // console.log('NOT LOGGED IN')
              return
            }

            // console.error(err)
            return Promise.reject(err)
          })

        return whenAuth
      },

      SIGNUP: ({ commit, dispatch }, user) => client
        .getService('signup')
        .create(user)
        .then((res) => {
          // add user to state
          if (isArray(res)) commit('ADD_USERS', res)

          return Promise.resolve()
        }),

      VALIDATE_EMAIL: ({}, { id, code }) => {
        return client.getService('signup').patch(id, { code })
      },

      FIND_SIGNUP: ({}, query) => {
        return client.getService('signup').find({ query })
      },

      UPDATE_SIGNUP: ({}, data) => {
        return client.getService('signup').update(null, data)
      },

      INVITE_EMAIL: ({}, { email }) => {
        return client.getService('signup').create({ email })
      },

      // LOGIN_OAUTH: ({ commit, dispatch }, { provider, code }) =>
      //   client.getService(`auth/${provider}/callback`).find({
      //     query: {
      //       code,
      //     },
      //   })
      //   .then(response => verifyJWT(response))
      //   .then((payload) => {
      //     if (payload.user.is_new) {
      //       dispatch('GEVENT', { category: 'Signup', action: 'NewSocial' })
      //     }
      //     return handlePayload(payload, commit)
      //   })
      //   .catch(err => console.error(err)),

      // REFRESH_TOKEN: () => client
      //   .getService('/auth/token/refresh')
      //   .find({})
      //   .then((token) => {
      //     console.log('token', token)
      //     return Promise.resolve(token)
      //   }),

      LOGIN: ({ commit }, { email, password }) => client
        .authenticate({
          strategy: 'local',
          email,
          password,
        })
        .then(response => verifyJWT(response))
        .then(payload => handlePayload(payload, commit)),

      LOGOUT: ({ commit, dispatch }) => client
        .logout()
        .then(() => {
          delete window.localStorage['feathers-jwt']
          // check(app.$route)
          commit('LOGOUT')
          dispatch('CLEAR_STATE')
          return Promise.resolve()
        }),
    },
    mutations: {
      LOGOUT: state => {
        state._user = {}
      },

      SET_AUTH_SKIP: (state, doSkip) => {
        state.doSkip = doSkip
      },

      SET_PROFILE: (state, { user }) => {
        state._user = user
        if (bugsnagClient) {
          bugsnagClient.user = {
            id: user.id,
            name: `${user.firstName || ''} ${user.lastName || ''}`,
            email: user.email,
          }
        }
      },
    },
    getters: {
      _user: state =>
        state._user,
      _settings: ({ _user, isAuth }) =>
        isAuth ? _user.settings : {},

      authHeaders: () => {
        const Authorization = window.localStorage['feathers-jwt']
        return Authorization ? { Authorization } : {}
      },
      isAuth: state =>
        !empty(state._user),
      isAdmin: (_, getters) => getters.hasRoles('ADM+'),

      roles: () => ({
        MAS: { name: 'Master', theme: 'info' },
        ADM: { name: 'Admin', theme: 'info' },
        MOD: { name: 'Moderator', theme: 'info' },
        OWN: { name: 'Owner', theme: 'success' },
        SUP: { name: 'Supervisor' },
        USR: { name: 'User' },
      }),

      roleKeys: (_, getters) => Object.keys(getters.roles),

      rolesOptions: statusOptions('roles'),

      getRole: (_, getters) => role => getters.roles[role],

      parseRoles: (_, getters) => roles =>
        castArray(roles).reduce((arr, role) => {
          let push = [role]
          if (role.includes('+')) {
            const index = getters.roleKeys.indexOf(role.replace('+', ''))
            push = [...getters.roleKeys].splice(0, index + 1)
          }
          return [...arr, ...push]
        }, []),

      hasRoles: (_, { isAuth, _user, parseRoles }) => roles => {
        const parsed = parseRoles(roles)
        return isAuth && _user.roles.some(role => parsed.includes(role))
      },

      routeAfterLogin: (_, { hasPermissions }) =>
        hasPermissions('jobcards.read')
          ? 'Board'
          : 'Invoices',

      whenAuth: () => whenAuth,

      // hasGroupRole: (_, { isAuth, _membership, parseRoles }) => roles => {
      //   const parsed = parseRoles(roles)
      //   return isAuth && _membership.role.some(role => parsed.includes(role))
      // },
    },
  }
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/store/modules/auth.js